<template>
  <CModal
    title="เพิ่มการแจ้งเตือน"
    :show.sync="isShow"
    :closeOnBackdrop="false"
    @update:show="closeModal"
    centered
  >
    <CRow form class="form-group">
      <CCol sm="4">
        ส่งถึง
      </CCol>
      <CCol sm="8">
        <CSelect :value.sync="typeSelected" :options="typeOptions" disabled/>
        <CInput
          v-if="typeSelected === 'single'"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          placeholder="User ID"
          v-model="info.user_id"
        />
        <CInputRadioGroup
          v-else
          :options="groupOptions"
          custom
          :checked.sync="info.topic"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          label="หัวข้อ"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          v-model="info.title"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          label="ข้อความ"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          v-model="info.message"
        />
      </CCol>
    </CRow>

    <CRow v-if="errorMessage">
      <CCol sm="12" class="text-danger text-center">
        <span v-html="errorMessage"></span>
      </CCol>
    </CRow>

    <template slot="footer">
      <CButton color="secondary" variant="outline" @click="cancle">
        ยกเลิก
      </CButton>
      <CButton color="success" @click="confirm">
        ยืนยัน
      </CButton>
    </template>
  </CModal>
</template>

<script>
import apiNotification from '@/apis/notification'

export default {
  name: 'NotificationAddModal',
  props: {
    onComplete: Function
  },
  data() {
    return {
      isShow: false,
      info: { user_id: '', topic: 'volunteers', title: '', message: '' },
      typeSelected: 'single',
      typeOptions: [
        { value: 'single', label: 'รายบุคคล' },
        { value: 'group', label: 'รายกลุ่ม' }
      ],
      groupOptions: [
        {
          value: 'volunteers',
          label: 'ส่งถึงอาสาสมัคร'
        },
        {
          value: 'admins',
          label: 'ส่งถึงแอดมิน'
        },
        {
          value: 'blinds',
          label: 'ส่งถึงสมาชิก 1414Plus'
        },
        {
          value: 'ios',
          label: 'ส่งถึงผู้ใช้งาน iOS'
        },
        {
          value: 'android',
          label: 'ส่งถึงผู้ใช้งาน Android'
        },
        {
          value: 'all',
          label: 'ส่งถึงทุกคน'
        }
      ],
      errorMessage: ''
    }
  },
  methods: {
    show(id) {
      this.info.user_id = id
      this.isShow = true
      this.errorMessage = ''
    },
    clear() {
      setTimeout(() => {
        this.info = { user_id: '', topic: 'volunteers', title: '', message: '' }
      }, 500)
    },
    cancle() {
      this.isShow = false
      this.clear()
    },
    imageChange(files) {
      this.uploadImage = files[0]
    },
    async confirm() {
      if (this.typeSelected === 'single' && !this.info.user_id) {
        this.errorMessage = 'ต้องกรอก <b>User ID</b>'
        return
      }
      if (this.typeSelected === 'group' && !this.info.topic) {
        this.errorMessage = 'ต้องเลือก <b>รายกลุ่ม</b>'
        return
      }
      if (!this.info.title) {
        this.errorMessage = 'ต้องกรอก <b>หัวข้อ</b>'
        return
      }
      if (!this.info.message) {
        this.errorMessage = 'ต้องกรอก <b>ข้อความ</b>'
        return
      }
      try {
        if (this.typeSelected === 'single') delete this.info.topic
        else delete this.info.user_id

        apiNotification.create(this.info).then(() => {
          // this.onComplete()
        })

        this.isShow = false
        this.clear()
      } catch {}
    },
    closeModal() {
      this.clear()
    }
  }
}
</script>
